import { ChatUserRolesEnum } from 'src/common/chat/user-roles.enum';
import { InboxMessageStack } from '../store';

export const getListConversationText = (members: InboxMessageStack['members']) => {
  const names = members.map((m, i) => (m.role === ChatUserRolesEnum.CREATOR ? (i === 0 ? 'You' : 'you') : m.name));
  const { length: count } = names;
  let copy = '';
  if (count === 1) {
    copy = `${names[0]} left a comment`;
  } else if (count === 2) {
    copy = `${names[0]}, ${names[1]} left comments`;
  } else if (count === 3) {
    copy = `3 people left comments`;
  } else if (count > 3) {
    copy = `${names[0]}, ${names[1]} and ${count - 2} others left comments`;
  }

  return copy;
};
